import React, { useEffect, useState } from 'react';
import api from '../api';

function AdminTickets() {
  const [tickets, setTickets] = useState([]);
  const [response, setResponse] = useState('');

  useEffect(() => {
    api.get('/api/admin/tickets')
      .then(res => setTickets(res.data))
      .catch(err => console.error('AdminTickets error:', err));
  }, []);

  const handleRespond = async (id, status) => {
    try {
      await api.patch(`/api/admin/tickets/${id}`, {
        adminResponse: response,
        status,
      });
      setTickets(prev => prev.map(t => t.id === id ? { ...t, adminResponse: response, status } : t));
      setResponse('');
    } catch (err) {
      alert(err.response?.data?.error || 'Response failed');
    }
  };

  return (
    <div>
      <h2>Support Tickets Management</h2>
      {tickets.length === 0 ? (
        <p>No tickets.</p>
      ) : (
        <div className="table-box">
          <table>
            <thead>
              <tr>
                <th>User</th>
                <th>Subject</th>
                <th>Message</th>
                <th>Status</th>
                <th>Response</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {tickets.map(ticket => (
                <tr key={ticket.id}>
                  <td>{ticket.User?.email}</td>
                  <td>{ticket.subject}</td>
                  <td>{ticket.message}</td>
                  <td>{ticket.status}</td>
                  <td>{ticket.adminResponse || '—'}</td>
                  <td>
                    {ticket.status !== 'resolved' && (
                      <>
                        <input
                          type="text"
                          placeholder="Response"
                          value={response}
                          onChange={e => setResponse(e.target.value)}
                          style={{ marginRight: '0.5rem', padding: '0.25rem' }}
                        />
                        <button
                          onClick={() => handleRespond(ticket.id, 'in_progress')}
                          style={{ background: '#3b82f6', color: 'white', border: 'none', padding: '0.25rem 0.5rem', borderRadius: '0.25rem', marginRight: '0.25rem', cursor: 'pointer' }}
                        >
                          Mark In Progress
                        </button>
                        <button
                          onClick={() => handleRespond(ticket.id, 'resolved')}
                          style={{ background: '#10b981', color: 'white', border: 'none', padding: '0.25rem 0.5rem', borderRadius: '0.25rem', cursor: 'pointer' }}
                        >
                          Resolve
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
export default AdminTickets;